<!-- src/shared/components/logos/SheepLogo.vue -->
<script setup lang="ts">
  defineProps<{ size?: number }>()
</script>

<template>
  <svg
    :width="size ?? 64"
    :height="size ?? 64"
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Sheep">

    <!-- Wool puffs -->
    <circle cx="50" cy="14" r="17" fill="#e8e8e8"/>
    <circle cx="22" cy="26" r="15" fill="#e0e0e0"/>
    <circle cx="78" cy="26" r="15" fill="#e0e0e0"/>
    <circle cx="11" cy="50" r="13" fill="#d8d8d8"/>
    <circle cx="89" cy="50" r="13" fill="#d8d8d8"/>
    <circle cx="20" cy="74" r="13" fill="#d8d8d8"/>
    <circle cx="80" cy="74" r="13" fill="#d8d8d8"/>
    <circle cx="50" cy="86" r="13" fill="#d4d4d4"/>

    <!-- Ears -->
    <ellipse cx="17" cy="46" rx="9" ry="13" fill="#c8967a" transform="rotate(-15 17 46)"/>
    <ellipse cx="83" cy="46" rx="9" ry="13" fill="#c8967a" transform="rotate(15 83 46)"/>

    <!-- Face -->
    <ellipse cx="50" cy="54" rx="26" ry="28" fill="#f5ede0"/>

    <!-- Eyes -->
    <ellipse cx="39" cy="47" rx="5" ry="6" fill="#1a1209"/>
    <ellipse cx="61" cy="47" rx="5" ry="6" fill="#1a1209"/>
    <circle cx="41" cy="45" r="1.5" fill="white"/>
    <circle cx="63" cy="45" r="1.5" fill="white"/>

    <!-- Nose -->
    <ellipse cx="50" cy="63" rx="8" ry="5" fill="#e8a090"/>
    <ellipse cx="46" cy="64" rx="2.2" ry="2.5" fill="#b06060"/>
    <ellipse cx="54" cy="64" rx="2.2" ry="2.5" fill="#b06060"/>

    <!-- Mouth -->
    <path d="M 44 70 Q 50 75 56 70" stroke="#b06060" stroke-width="1.5" fill="none" stroke-linecap="round"/>
  </svg>
</template>
